import React from "react";

const ExpressJSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 255.995 255.995"
    >
      <defs>
        <linearGradient
          id="color-1"
          x1="3.851"
          x2="34.471"
          y1="2.596"
          y2="33.216"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6d7479"></stop>
          <stop offset="1" stopColor="#323538"></stop>
        </linearGradient>
      </defs>
      <g
        fill="#fff"
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        style={{ mixBlendMode: "normal" }}
      >
        <path d="M0 255.995V0h255.995v255.995z"></path>
      </g>
      <path
        fill="url(#color-1)"
        strokeMiterlimit="10"
        d="M33.244 25l-9.121-12h1.18c.84 0 1.631.392 2.139 1.061l7.059 9.287 7.059-9.287A2.681 2.681 0 0143.698 13h1.18l-9.121 12 9.547 12.56h-1.18c-.84 0-1.631-.392-2.139-1.061L34.5 26.652l-7.485 9.847a2.687 2.687 0 01-2.139 1.061h-1.18zM4 26v.783c0 4.199 2.776 8.032 6.868 8.972 4.439 1.02 8.49-1.247 10.228-4.842.27-.558.832-.913 1.451-.913h1.028c-1.319 4.655-5.616 8.059-10.707 7.999C6.777 37.927 2 32.694 2 26.142V23.284c0-5.427 3.812-10.273 9.171-11.136C18.055 11.039 24 16.325 24 23v3zm0-2h18v-1c0-5.648-5.202-10.08-11.076-8.768C6.804 15.153 4 19.002 4 23.71z"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        transform="scale(5.33333)"
      ></path>
    </svg>
  );
};

export default ExpressJSIcon;
